import { createStore } from 'vuex';
import auth from './auth';
import profile from './profile';
import settings from './settings';
import feed from './feed';
import billing from './billing';
import shop from './shop';
import dashboard from './dashboard';

const store = createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    profile,
    settings,
    feed,
    billing,
    shop,
    dashboard,
  },
});

export default store;
